import React, { useEffect, useState } from "react";
import { callApi } from "../../../ApiHelper/ApiHelper";
import { Controller, useForm } from "react-hook-form";
import { DatePicker } from "rsuite";
import ErrorMessage from "../../../components/comman/ErrorMessage";
import { formatAmount, parseAmount } from "../../../utility/CommonFunctions";
import calculateFinancialYears, { getCurrentFinancialYear } from "../../../utility/CommonFunctions";
import { apiUrl } from "../../../ApiHelper/ApiUrl";
import { toast } from "react-toastify";
import moment from "moment";
import { Spinner } from "reactstrap";
import DeleteIcon from "../../../components/Icons/DeleteIcon";
import { useSelector } from "react-redux";
import UploadPlusIcon from "../../../components/Icons/UploadPlusIcon";
import { useLocation, useNavigate } from "react-router-dom";
import BackArrowIcon from "../../../components/Icons/BackArrowIcon";
import SearchSelectInput from "../../../components/comman/SearchSelectInput";
import { errorTypes } from "../../../utility/InputValidation";
import ViewDocumentModal from "../../Sites/ViewDocumentModal";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

export default function CreateReimbursement() {
  const [isLoading, setIsLoading] = useState(false);
  const userDetails = useSelector((state) => state.root.userDetails);
  const navigate = useNavigate();
  const location = useLocation();
  const EditData = location?.state?.data;
  // console.log("EditData====>",EditData);
  const [existingDocuments, setExistingDocuments] = useState([]);
  const [selectedDocument, setSelectedDocument] = useState();
  const [modal, setModal] = useState(false);
  const toggleModal = () => {
    setModal(!modal);
  };
  const [files, setFiles] = useState([]);

  // Financial Year State
  const [financialYears, setFinancialYears] = useState([]);
  const [activeFinancialYear, setActiveFinancialYear] = useState("");

  const [state, setState] = useState({
    expenseList: [],
    expenseId: "",
    expenseLoading: false,
    generalItems: [],
    OandMSites: [],
    projectSites: [],
    assignedSites: [],
    expenseHeadItems: [],
    siteId: "",
    siteName: "",
    rate: "",
    prevUnitRate: "",
    gst: "",
    quantity: "",
    validateQuantity: "",
    validateAmount: "",
    remainingAmount: 0,
    unit: "unit",
    gstType: "",
    taxableAmount: "",
    paymentTicketDetail: [],
    empListLoading: false,
    isLoadingSite: false,
    empList: [],
    empId: "",
    empname: "",
  });

  // console.log("state=========>", state);

  const handleFinancialYearCalculation = (site) => {
    let date = new Date();
    if (site?.startDate) {
      date = new Date(site?.startDate);
    }
    const years = calculateFinancialYears(date, site?.endDate);
    setFinancialYears(years);

    let fyToSet;

    if (years.length > 0) {
      const currentMonth = new Date().getMonth() + 1; // 1-12
      const currentYear = new Date().getFullYear();
      let defaultYear;

      if (currentMonth >= 4) {
        defaultYear = `${currentYear}-${currentYear + 1}`;
      } else {
        defaultYear = `${currentYear - 1}-${currentYear}`;
      }

      if (years.includes(defaultYear)) {
        fyToSet = defaultYear;
      } else {
        fyToSet = years[years.length - 1];
      }
    } else {
      fyToSet = getCurrentFinancialYear();
      setFinancialYears([fyToSet]);
    }

    setActiveFinancialYear(fyToSet);
    setValue("financialYear", fyToSet);
    return fyToSet;
  };

  const {
    register,
    handleSubmit,
    reset,
    watch,
    setValue,
    formState: { errors },
    control,
    clearErrors,
  } = useForm();

  useEffect(() => {
    if (location?.state?.data) {
      let options = {
        method: "GET",
      };
      let API =
        apiUrl?.get_payment_ticket_details +
        `paymentTicketId=${location?.state?.data?.id}`;
      setState((prev) => ({
        ...prev,
        ptDataLoading: true,
      }));
      callApi(API, options).then((response) => {
        setState((prev) => ({
          ...prev,
          ptDataLoading: false,
        }));
        if (response?.status === true) {
          // console.log("res", response?.data);
          setState((prev) => ({
            ...prev,
            paymentTicketDetail: response?.data,
          }));
          fetchPurchaseOrderList(response?.data?.site?.id, response?.data?.financialYear);
        }
      });
    }
  }, []);


  useEffect(() => {
    if (
      userDetails?.type === 2 &&
      (state?.OandMSites.length === 0 || state?.assignedSites.length === 0)
    ) {
      GetAllSitesList();
    } else if (
      state?.OandMSites.length === 0 ||
      state?.assignedSites.length === 0
    ) {
      getAssignedSites();
    }

    if (location?.state?.data) {
      setState((pre) => ({
        ...pre,
        siteId: state?.paymentTicketDetail?.site?.id,
        empId: state?.paymentTicketDetail?.recipientId || state?.paymentTicketDetail?.receipientUser?.id,
        siteName: state?.paymentTicketDetail?.site?.name,
        empname: state?.paymentTicketDetail?.beneficiaryName || state?.paymentTicketDetail?.receipientUser?.name,
        quantity:
          state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
            ?.paymentticketitems?.[0]?.quantity,
        rate: state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
          ?.paymentticketitems?.[0]?.rate,
        gstType: state?.paymentTicketDetail?.gstType,
        gst: state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
          ?.paymentticketitems?.[0]?.gst,
        expenseId:
          state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
            ?.expenseHeadId,
        taxableAmount: formatAmount(
          state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
            ?.paymentticketitems?.[0]?.taxableAmount
        ),
      }));

      // Calculate Financial Year on Edit
      if (state?.paymentTicketDetail?.site) {
        handleFinancialYearCalculation(state?.paymentTicketDetail?.site);
      }
      if (state?.paymentTicketDetail?.financialYear) {
        setActiveFinancialYear(state?.paymentTicketDetail?.financialYear);
        setValue("financialYear", state?.paymentTicketDetail?.financialYear);
      }

      setValue("siteId", state?.paymentTicketDetail?.site?.id);
      setValue("empId", state?.paymentTicketDetail?.receipientUser?.id);
      setValue(
        "quantity",
        state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
          ?.paymentticketitems?.[0]?.quantity
      );
      setValue(
        "rate",
        state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
          ?.paymentticketitems?.[0]?.rate
      );
      setValue(
        "taxableAmount",
        formatAmount(
          state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
            ?.paymentticketitems?.[0]?.taxableAmount
        )
      );
      setValue("gstType", state?.paymentTicketDetail?.gstType);
      setValue(
        "gst",
        state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]
          ?.paymentticketitems?.[0]?.gst
      );
      setValue("content", state?.paymentTicketDetail?.description || "");
      setValue("name", state?.paymentTicketDetail?.beneficiaryName || state?.paymentTicketDetail?.receipientUser?.name || state?.paymentTicketDetail?.receipientUser?.id);
      setValue("phone", state?.paymentTicketDetail?.phone || state?.paymentTicketDetail?.receipientUser?.phone);
      setValue(
        "bankName",
        state?.paymentTicketDetail?.bankName || state?.paymentTicketDetail?.receipientUser?.userdetail?.bankName
      );
      setValue(
        "ifscCode",
        state?.paymentTicketDetail?.ifscCode || state?.paymentTicketDetail?.receipientUser?.userdetail?.ifscCode
      );
      setValue(
        "accountHolderName",
        state?.paymentTicketDetail?.accountHolderName || state?.paymentTicketDetail?.receipientUser?.userdetail
          ?.accountHolderName
      );
      setValue(
        "accountNumber",
        state?.paymentTicketDetail?.accountNumber || state?.paymentTicketDetail?.receipientUser?.userdetail?.accountNumber
      );
      setValue(
        "branchName",
        state?.paymentTicketDetail?.branchName || state?.paymentTicketDetail?.branchAddress || state?.paymentTicketDetail?.receipientUser?.userdetail?.branchAddress
      );
      setValue(
        "date",
        moment(state?.paymentTicketDetail?.date).format("YYYY-MM-DD")
      );
      setValue(
        "expenseMonth",
        state?.paymentTicketDetail?.expenseMonth || ""
      );
      if (state?.paymentTicketDetail?.documents?.length > 0) {
        setExistingDocuments(state?.paymentTicketDetail?.documents);
      }
    }
  }, [state?.paymentTicketDetail]);

  useEffect(() => {
    if (location?.state?.data && state?.paymentTicketDetail && state?.expenseList?.length > 0) {
      const expenseHeadId = state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]?.expenseHeadId;
      if (expenseHeadId) {
        setValue("expenseName", expenseHeadId);
        const selectedBudget = state?.expenseList?.find(
          (item) => item?.expensehead?.id === expenseHeadId
        );
        const siteItems = selectedBudget?.sitebudgetitems || [];
        const remainingAmount = selectedBudget
          ? (+selectedBudget.expectedAmount || 0) - (+selectedBudget.freezedAmount || 0)
          : 0;
        
        setState((prev) => {
          if (JSON.stringify(prev.expenseHeadItems) !== JSON.stringify(siteItems) || prev.remainingAmount !== remainingAmount) {
            return { ...prev, expenseHeadItems: siteItems, remainingAmount: remainingAmount };
          }
          return prev;
        });
      }
    }
  }, [state?.expenseList, state?.paymentTicketDetail]);

  useEffect(() => {
    if (location?.state?.data && state?.paymentTicketDetail && state?.expenseHeadItems?.length > 0) {
      const itemId = state?.paymentTicketDetail?.paymentticketexpenseheads?.[0]?.paymentticketitems?.[0]?.itemId;
      if (itemId) {
        const selectedItem = state?.expenseHeadItems?.find(item => item?.itemId === itemId);
        if (selectedItem) {
          setValue("expenseHeadItems", itemId);
          setState((prev) => {
            const newValidateQty = +selectedItem?.quantity - +selectedItem?.freezedQuantity;
            const newValidateAmt = +selectedItem?.unitRate;
            const newPrevUnitRate = +selectedItem?.unitRate;
            if (prev.validateQuantity !== newValidateQty ||
                prev.validateAmount !== newValidateAmt ||
                prev.prevUnitRate !== newPrevUnitRate) {
              return {
                ...prev,
                validateQuantity: newValidateQty,
                validateAmount: newValidateAmt,
                prevUnitRate: newPrevUnitRate,
              };
            }
            return prev;
          });
        }
      }
    }
  }, [state?.expenseHeadItems, state?.paymentTicketDetail]);

  const getAssignedSites = (inputValue) => {
    const option = {
      method: "GET",
    };
    const url = `${apiUrl?.get_user_site}${inputValue ? `?search=${inputValue}` : ""
      }`;
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    callApi(url, option).then((res) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (res?.status === true) {
        setState((prev) => ({
          ...prev,
          assignedSites: res?.data?.site?.map((item) => ({
            ...item,
            label: item?.site?.name,
            value: item?.site?.id,
          })),
        }));
      } else {
        toast.error(res?.message);
      }
    });
  };

  const GetAllSitesList = (inputValue = null) => {
    let options = {
      method: "GET",
    };
    setState((prev) => ({
      ...prev,
      isLoadingSite: true,
    }));
    let API =
      apiUrl.get_site +
      `?type=site${inputValue ? `&search=${inputValue}` : ""}`;
    callApi(API, options).then((response) => {
      setState((prev) => ({
        ...prev,
        isLoadingSite: false,
      }));
      if (response?.status === true) {
        setState((prev) => ({
          ...prev,
          OandMSites: response?.data?.site
            ?.filter((item) => item?.type === "O&M")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
          projectSites: response?.data?.site
            ?.filter((item) => item?.type === "project")
            ?.map((item) => ({
              ...item,
              label: item?.site?.name,
              value: item?.site?.id,
            })),
        }));
      }
    });
  };

  const fetchPurchaseOrderList = (siteId, fy) => {
    return new Promise((resolve) => {
      let API = `${apiUrl.get_site_budget}&siteId=${siteId}&financialYear=${fy || activeFinancialYear || getCurrentFinancialYear()}`;
      let options = { method: "GET" };

      setState((prev) => ({ ...prev, expenseLoading: true }));

      callApi(API, options).then((response) => {
        setState((prev) => ({ ...prev, expenseLoading: false }));

        if (response?.status) {
          const list = response?.data || [];
          setState((prev) => ({ ...prev, expenseList: list }));

          if (!response?.data?.[0]) {
            toast.error("Expense Head not found in selected site or financial year!");
            setState((prev) => ({ ...prev, expenseHeadItems: [] }));
            setValue("expenseName", "");
            setValue("expenseHeadItems", "");
            setState((pre) => ({
              ...pre,
              validateQuantity: "",
              validateAmount: "",
              remainingAmount: 0,
              quantity: "",
              prevUnitRate: "",
            }));
            clearErrors();
            return;
          }

          setValue("expenseName", response?.data?.[0]?.expensehead?.id);

          const siteItems = response?.data?.[0]?.sitebudgetitems || [];
          setState((prev) => ({ ...prev, expenseHeadItems: siteItems }));

          const selectedBudget = response?.data?.[0];
          const remainingAmount = selectedBudget
            ? (+selectedBudget.expectedAmount || 0) - (+selectedBudget.freezedAmount || 0)
            : 0;

          if (siteItems.length > 0) {
            setValue("expenseHeadItems", siteItems[0]?.itemId);
            setState((pre) => ({
              ...pre,
              validateQuantity:
                +siteItems[0]?.quantity - +siteItems[0]?.freezedQuantity,
              validateAmount: +siteItems[0]?.unitRate,
              prevUnitRate: +siteItems[0]?.unitRate,
              remainingAmount: remainingAmount,
            }));
          } else {
            setState((pre) => ({
              ...pre,
              validateQuantity: "",
              validateAmount: "",
              prevUnitRate: "",
              remainingAmount: remainingAmount,
            }));
          }
        } else {
          toast.error(response?.message);
        }
      });
    });
  };

  const handleExpenseNameChange = (e) => {
    const selectedExpenseHeadId = e.target.value;
    setValue("expenseName", selectedExpenseHeadId);

    const selectedBudget = state?.expenseList?.find(
      (item) => item?.expensehead?.id === selectedExpenseHeadId
    );

    const siteItems = selectedBudget?.sitebudgetitems || [];
    setState((prev) => ({ ...prev, expenseHeadItems: siteItems }));

    const remainingAmount = selectedBudget
      ? (+selectedBudget.expectedAmount || 0) - (+selectedBudget.freezedAmount || 0)
      : 0;

    if (siteItems.length > 0) {
      setValue("expenseHeadItems", siteItems[0]?.itemId);
      setState((pre) => ({
        ...pre,
        validateQuantity: +siteItems[0]?.quantity - +siteItems[0]?.freezedQuantity,
        validateAmount: +siteItems[0]?.unitRate,
        prevUnitRate: +siteItems[0]?.unitRate,
        remainingAmount: remainingAmount,
      }));
    } else {
      setValue("expenseHeadItems", "");
      setState((pre) => ({
        ...pre,
        validateQuantity: "",
        validateAmount: "",
        prevUnitRate: "",
        remainingAmount: remainingAmount,
      }));
    }
  };

  const handleItemChange = (e) => {
    const selectedItemId = e.target.value;
    setValue("expenseHeadItems", selectedItemId);

    const selectedItem = state?.expenseHeadItems?.find(
      (item) => item?.itemId === selectedItemId
    );

    if (selectedItem) {
      setState((pre) => ({
        ...pre,
        validateQuantity: +selectedItem?.quantity - +selectedItem?.freezedQuantity,
        validateAmount: +selectedItem?.unitRate,
        prevUnitRate: +selectedItem?.unitRate,
      }));
    }
  };

  useEffect(() => {
    if (state?.siteId) {
      handleSearchEmp();
    }
  }, [state?.siteId]);

  const handleSearchEmp = async (data = null) => {
    setState((pre) => ({ ...pre, empListLoading: true }));
    const siteName = state?.siteId || "";
    let API = `${apiUrl.site_users}?siteId=${siteName}&from=reimbursementForm${data ? `&search=${data}` : ""
      }`;

    const response = await callApi(API);
    if (response?.status) {
      setState((pre) => ({
        ...pre,
        empList: response?.data?.user?.map((item) => ({
          ...item,
          label: item?.user?.name,
          value: item?.user?.id,
        })),
        empListLoading: false,
        ...(pre.empId ? { empId: "" } : {}),
      }));
      setValue("name", "");
    }
    return response;
  };

  const onSelectEmp = (data) => {
    const findUser = state?.empList?.find(
      (user) => user?.user?.id === data?.value
    )?.user;
    setState((prev) => ({
      ...prev,
      empId: data?.value,
      empname: data?.user?.name,
    }));

    setValue("empId", data?.value);
    setValue("name", findUser?.name);
    setValue("phone", findUser?.phone);
    setValue("bankName", findUser?.userdetail?.bankName);
    setValue("accountHolderName", findUser?.userdetail?.accountHolderName);
    setValue("accountNumber", findUser?.userdetail?.accountNumber);
    setValue("ifscCode", findUser?.userdetail?.ifscCode);
    setValue("branchName", findUser?.userdetail?.branchAddress);
    // setError((pre) => ({
    //   ...pre,
    //   empError: data ? "" : "This field is Required",
    // }));
  };

  const handleUpdateAmountWithGst = (e) => {
    let { name, value } = e.target;

    value = value.replace(/[^0-9.]/g, "").replace(/(\..*)\./g, "$1");

    const formatValue = (num) => {
      return num % 1 === 0 ? num.toFixed(0) : num.toFixed(2);
    };

    setState((prev) => {
      const updated = { ...prev, [name]: value };

      let qtyVal = parseFloat(updated.quantity);
      let rateVal = parseFloat(updated.prevUnitRate);
      let amtVal = parseFloat(updated.rate);

      let qty = isNaN(qtyVal) ? 0 : qtyVal;
      let rate = isNaN(rateVal) ? 0 : rateVal;
      let amount = isNaN(amtVal) ? 0 : amtVal;

      if (name === "rate") {
        qty = rate ? amount / rate : 0;
        setValue("quantity", value === "" ? "" : formatValue(qty));
        setValue("rate", value, { shouldValidate: true });
        updated.quantity = value === "" ? "" : formatValue(qty);
        updated.rate = value;
      } else if (name === "quantity") {
        amount = qty * rate;
        setValue("rate", value === "" ? "" : formatValue(amount), { shouldValidate: true });
        setValue("quantity", value);
        updated.rate = value === "" ? "" : formatValue(amount);
        updated.quantity = value;
      } else if (name === "prevUnitRate") {
        amount = qty * rate;
        setValue("rate", value === "" ? "" : formatValue(amount), { shouldValidate: true });
        setValue("prevUnitRate", value);
        updated.rate = value === "" ? "" : formatValue(amount);
        updated.prevUnitRate = value;
      } else {
        amount = qty * rate;
        setValue("rate", formatValue(amount), { shouldValidate: true });
        setValue("quantity", formatValue(qty));
        setValue("prevUnitRate", formatValue(rate));
        updated.rate = formatValue(amount);
        updated.quantity = formatValue(qty);
        updated.prevUnitRate = formatValue(rate);
      }

      const gst = parseFloat(updated.gst) || 0;
      const subtotal = amount;
      const gstAmount = (subtotal * gst) / 100;
      const taxableAmount = subtotal + gstAmount;

      setValue("taxableAmount", formatAmount(taxableAmount));

      return {
        ...updated,
        subtotal,
        gstAmount,
        taxableAmount,
      };
    });
  };

  const handleFileChange = (event) => {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      if (selectedFile.size > 6 * 1024 * 1024) {
        toast.error("File size must be less than 6MB");
        event.target.value = "";
        return;
      }
      setFiles((prevFiles) => [
        ...prevFiles,
        { key: selectedFile.name, file: selectedFile },
      ]);
    }
    event.target.value = "";
  };

  const removeFile = (fileName) => {
    setFiles((prevFiles) =>
      prevFiles.filter((fileObj) => fileObj.key !== fileName)
    );
  };

  const handleDeleteDocument = (docId) => {
    const API = `${apiUrl.delete_document}?documentId=${docId}`;
    callApi(API, { method: "GET" }).then((response) => {
      if (response?.status === true) {
        setExistingDocuments((prev) => prev.filter((doc) => doc.id !== docId));
        // toast.success(response.message);
      } else {
        toast.error(response.message);
      }
    });
  };

  const onSubmit = (data) => {
    const postData = {
      type: "Reimbursement",
      date: data?.date,
      expenseMonth: data?.expenseMonth,
      siteId: state?.siteId,
      totalAmount: parseAmount(data?.taxableAmount),
      gstType: data?.gstType,
      description: data?.content,
      paymentTicketExpenseHead: JSON.stringify([
        {
          expenseHeadId: data?.expenseName,
          amount: parseAmount(data?.taxableAmount),
          gst: data?.gst,
          taxableAmount: parseAmount(data?.taxableAmount),
          paymentTicketItem: [
            {
              itemId: data?.expenseHeadItems || null,
              quantity: data?.quantity,
              rate: state?.prevUnitRate,
              gst: data?.gst,
              taxableAmount: parseAmount(data?.taxableAmount),
            },
          ],
        },
      ]),
      recipientId: state?.empId,
      financialYear: activeFinancialYear,
      bankName: data?.bankName,
      accountHolderName: data?.accountHolderName,
      accountNumber: data?.accountNumber,
      ifscCode: data?.ifscCode,
      branchName: data?.branchName,
      beneficiaryName: data?.name || state?.empname,
      phone: data?.phone,
    };

    // console.log("postData======>", postData);

    const formData = new FormData();
    Object.keys(postData).forEach((key) => {
      const value = postData[key];
      if (value) {
        formData.append(key, value);
      }
    });

    if (files?.length > 0) {
      files.forEach((fileObj) => {
        formData.append(fileObj?.file?.name, fileObj.file);
      });
    }

    const option = {
      method: "POST",
      form_data: formData,
    };
    setIsLoading(true);
    const url = EditData
      ? apiUrl.update_payment_ticket + `?paymentTicketId=${EditData?.id}`
      : apiUrl.create_payment_ticket;
    callApi(url, option).then((res) => {
      setIsLoading(false);
      if (res?.status) {
        toast.success(res?.message);
        navigate(-1);
      } else {
        toast.error(res?.message);
      }
    });
  };

  return (
    <>
      <div className="content container-fluid">
        <div className="content-head mb-5 d-flex align-items-center justify-content-between">
          <div className="d-flex align-items-center justify-content-start gap-4">
            <button
              role="button"
              className="btn back-arrow"
              onClick={() => navigate(-1)}
            >
              <BackArrowIcon />
            </button>
            <h1 className="mb-0">
              {location?.state?.data ? "Update" : "Create"} Reimbursement Ticket
            </h1>
          </div>
        </div>
        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="card">
            <div className="card-body">
              <div className="row">
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="bDate">
                      Date
                    </label>
                    <Controller
                      name="date"
                      control={control}
                      rules={{
                        required: "This field is Required",
                      }}
                      defaultValue={moment().format("YYYY-MM-DD")}
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="bDate"
                          format="dd/MM/yyyy"
                          oneTap
                          placeholder="dd/mm/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM-DD") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.date?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label" htmlFor="expenseMonth">
                      Expense Month<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="expenseMonth"
                      control={control}
                      rules={{ required: "Expense Month is required" }}
                      defaultValue=""
                      render={({ field }) => (
                        <DatePicker size="sm"
                          {...field}
                          id="expenseMonth"
                          format="MM/yyyy"
                          oneTap
                          placeholder="MM/yyyy"
                          style={{ width: "100%" }}
                          value={field.value ? new Date(field.value) : null}
                          onChange={(date) => {
                            field.onChange(date ? moment(date).format("YYYY-MM") : "");
                          }}
                          cleanable={false}
                        />
                      )}
                    />
                    <ErrorMessage message={errors?.expenseMonth?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <Controller
                      name="siteId"
                      control={control}
                      rules={{ ...errorTypes.required("site") }}
                      render={({ field, fieldState }) => (
                        <SearchSelectInput
                          label="Site"
                          placeholder="Search Site"
                          value={state.siteName}
                          onSelect={(option) => {
                            field.onChange(option?.value);
                            setState((pre) => ({
                              ...pre,
                              siteId: option?.value,
                              siteName: option?.label,
                            }));
                            const selectedSite =
                              userDetails?.type === 2
                                ? state?.OandMSites.find(
                                  (s) => s.site.id === option.value
                                )
                                : state.assignedSites.find(
                                  (s) => s.site.id === option.value
                                );
                            let newFy;
                            if (selectedSite) {
                              newFy = handleFinancialYearCalculation(selectedSite.site);
                            }
                            fetchPurchaseOrderList(option?.value, newFy);
                          }}
                          onBlur={field.onBlur}
                          errors={fieldState.error?.message}
                          options={
                            userDetails?.type === 2
                              ? state?.OandMSites
                              : state.assignedSites
                          }
                          onSearch={
                            userDetails?.type === 2
                              ? GetAllSitesList
                              : getAssignedSites
                          }
                          isLoading={state?.isLoadingSite}
                          showAddButton={false}
                          required={true}
                          disabled={state?.generalItems?.length !== 0}
                        />
                      )}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      Financial Year<span className="text-danger">*</span>
                    </label>
                    <Controller
                      name="financialYear"
                      control={control}
                      rules={{ required: "Financial Year is required" }}
                      render={({ field }) => (
                        <select
                          className="form-select"
                          {...field}
                          onChange={(e) => {
                            field.onChange(e.target.value);
                            setActiveFinancialYear(e.target.value);
                            fetchPurchaseOrderList(state.siteId, e.target.value);
                          }}
                          disabled={!state.siteId || !!location?.state?.data}
                          value={activeFinancialYear}
                        >
                          <option value="" disabled>
                            Select Financial Year
                          </option>
                          {financialYears?.map((fy) => (
                            <option key={fy} value={fy}>
                              {fy}
                            </option>
                          ))}
                        </select>
                      )}
                    />
                    <ErrorMessage message={errors?.financialYear?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3 position-relative">
                    <label htmlFor="customerSearch" className="form-label">
                      Expense Name
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("expenseName")}
                      onChange={handleExpenseNameChange}
                    >
                      <option value="" className="d-none">
                        Select Expense Name
                      </option>
                      {state?.expenseList?.map((item) => (
                        <option
                          value={item?.expensehead?.id}
                          key={item?.expensehead?.id}
                        >
                          {item?.expensehead?.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="expenseHead" className="form-label">
                      Item
                    </label>
                    <select
                      className="form-select form-control"
                      aria-label="Default select example"
                      {...register("expenseHeadItems")}
                      onChange={handleItemChange}
                    >
                      <option value="" className="d-none">
                        Select Items
                      </option>
                      {state?.expenseHeadItems?.map((items) => (
                        <option value={items?.itemId} key={items?.itemId}>
                          {items?.item?.name}
                        </option>
                      ))}
                    </select>

                    <ErrorMessage message={errors?.expenseHeadItems} />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="qty" className="form-label">
                      Quantity<span className="text-danger">*</span>
                    </label>
                    <div className="d-flex">
                      <input
                        type="text"
                        className="form-control"
                        placeholder="Enter Quantity"
                        {...register("quantity", {
                          required: "Quantity is required",
                        })}
                        name="quantity"
                        value={state.quantity || ""}
                        onChange={handleUpdateAmountWithGst}
                      />
                    </div>
                    <ErrorMessage message={errors?.quantity?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="expenseHead" className="form-label">
                      Rate<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Rate"
                      {...register("prevUnitRate")}
                      name="prevUnitRate"
                      value={state.prevUnitRate || ""}
                      onChange={handleUpdateAmountWithGst}
                    />
                  </div>
                </div>
                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="expenseHead" className="form-label">
                      Amount<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Enter Amount"
                      {...register("rate", {
                        required: "Amount is required",
                        pattern: {
                          value: /^[0-9]+(\.[0-9]{1,2})?$/,
                          message: "Enter a valid amount",
                        },
                        validate: (value) => {
                          const remaining = state?.remainingAmount;
                          if (remaining !== undefined && remaining !== null && !isNaN(remaining)) {
                            if (parseFloat(value) > remaining) {
                              return `Amount cannot exceed remaining amount: ${remaining}`;
                            }
                          }
                          return true;
                        }
                      })}
                      name="rate"
                      value={state.rate || ""}
                      onChange={handleUpdateAmountWithGst}
                    />

                    <ErrorMessage message={errors?.rate?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label className="form-label">
                      GST Type<span className="text-danger">*</span>
                    </label>
                    <select
                      className="form-select"
                      {...register("gstType", {
                        required: "Please select GST type",
                      })}
                      value={state.gstType || ""}
                      onChange={(event) => {
                        setState((prev) => ({
                          ...prev,
                          gstType: event.target.value,
                        }));
                      }}
                    >
                      <option value="" disabled>
                        Select GST Type
                      </option>
                      <option value="IGST">IGST</option>
                      <option value="CGST + SGST">CGST + SGST</option>
                    </select>

                    <ErrorMessage message={errors?.gstType?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="gst" className="form-label">
                      GST<span className="text-danger">*</span>
                    </label>
                    <select
                      id="gst"
                      className="form-select"
                      {...register("gst", { required: "Please select GST %" })}
                      onChange={(e) => {
                        handleUpdateAmountWithGst(e);
                      }}
                    >
                      <option value="" disabled>
                        Select GST %
                      </option>
                      <option value="0">0%</option>
                      <option value="5">5%</option>
                      <option value="12">12%</option>
                      <option value="18">18%</option>
                      <option value="28">28%</option>
                    </select>

                    <ErrorMessage message={errors?.gst?.message} />
                  </div>
                </div>

                <div className="col-12 col-md-6 col-lg-4">
                  <div className="form-group mb-3">
                    <label htmlFor="expenseHead" className="form-label">
                      Taxable Amount
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("taxableAmount")}
                      // value={state.taxableAmount || ""}
                      disabled
                    />
                  </div>
                </div>

                <div className="row my-4">
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3 position-relative">
                      <Controller
                        name="empId"
                        control={control}
                        rules={{ ...errorTypes.required("Beneficiary Name") }}
                        render={({ field, fieldState }) => (
                          <SearchSelectInput
                            label="Beneficiary Name"
                            placeholder="Search Employee"
                            value={state.empname}
                            onSelect={(option) => {
                              field.onChange(option?.value);
                              onSelectEmp(option);
                            }}
                            onBlur={field.onBlur}
                            errors={fieldState.error?.message}
                            options={state?.empList}
                            onSearch={handleSearchEmp}
                            isLoading={state?.empListLoading}
                            showAddButton={false}
                            required={true}
                            disabled={!state?.siteId}
                          />
                        )}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="MobileNO" className="form-label">
                        Mobile No. <span className="text-danger">*</span>
                      </label>
                      <input
                        type="tel"
                        className="form-control"
                        placeholder="Mobile No."
                        id="MobileNO"
                        {...register("phone", {
                          required: "Mobile Number is required",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Mobile number must be exactly 10 digits",
                          },
                        })}
                        onInput={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9]/g, "")
                            .slice(0, 10);
                        }}
                        disabled
                      />
                      <ErrorMessage message={errors?.phone?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="bankName" className="form-label">
                        Bank Name
                      </label>
                      <div className="input-group mb-3 DatePicker">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Bank Name"
                          {...register("bankName", {
                            // required: "Bank Name is required",
                          })}
                          disabled
                        />
                      </div>
                      <ErrorMessage message={errors?.bankName?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="accountHolderName" className="form-label">
                        Account Holder Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="holderName"
                        placeholder="Account Holder Name"
                        {...register("accountHolderName", {
                          // required: "Account holder name is required",
                        })}
                        disabled
                      />
                      <ErrorMessage
                        message={errors?.accountHolderName?.message}
                      />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="accountNumber" className="form-label">
                        Account Number
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="accountNumber"
                        placeholder="Account Number"
                        {...register("accountNumber", {
                          // required: "Account Number is required",
                        })}
                        onChange={(e) => {
                          e.target.value = e.target.value
                            .replace(/[^0-9.]/g, "") // Remove everything except numbers and dot
                            .replace(/^(\.)+/, "") // Prevent dot at the start
                            .replace(/(\..*)\./g, "$1"); // Prevent multiple dots
                        }}
                        disabled
                      />
                      <ErrorMessage message={errors?.accountNumber?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="accountNumber" className="form-label">
                        IFSC Code
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="accountNumber"
                        placeholder="IFSC Code"
                        {...register("ifscCode", {
                          // required: "required",
                        })}
                        disabled
                      />
                      <ErrorMessage message={errors?.ifscCode?.message} />
                    </div>
                  </div>
                  <div className="col-12 col-md-6 col-lg-4">
                    <div className="form-group mb-3">
                      <label htmlFor="accountNumber" className="form-label">
                        Branch Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="branchName"
                        placeholder="branchName"
                        {...register("branchName", {
                          // required: "required",
                        })}
                        disabled
                      />
                      <ErrorMessage message={errors?.branchName?.message} />
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12  " />
                  <div className="col-12 col-md-6 col-lg-5">
                    <div className="form-group mb-3">
                      <label className="form-label" htmlFor="ref">
                        Upload Bills
                      </label>
                      <input
                        type="file"
                        className="form-control d-none"
                        id="documentUpload"
                        accept="image/*,application/pdf"
                        onChange={handleFileChange}
                      />
                      <label
                        htmlFor="documentUpload"
                        className="form-label rounded-4 cursor-pointer d-flex align-items-center justify-content-center"
                        style={{
                          display: "inline-block",
                          cursor: "pointer",
                          padding: 5,
                          backgroundColor: "rgb(245, 245, 245)",
                          borderRadius: 8,
                          minWidth: 150,
                        }}
                      >
                        <div className="d-flex flex-column">
                          <span className="placeholder-img">
                            <UploadPlusIcon />
                          </span>
                          <span className="text-muted">Choose Files </span>
                        </div>
                      </label>
                      <div className="preview-section p-1 mt-3" />
                    </div>
                  </div>
                </div>
                {/* File Preview Section */}
                <div className="preview-section p-1 mt-3 col-lg-5">
                  {files?.length > 0 &&
                    files.map((fileObj) => (
                      <div
                        key={fileObj.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            setSelectedDocument(fileObj?.file);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{fileObj?.file?.name}</span>
                        </div>
                        <button
                          className="text-danger mx-2 bg-light"
                          onClick={() => removeFile(fileObj.key)} // Remove using file name
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}

                  {existingDocuments?.length > 0 &&
                    existingDocuments.map((doc) => (
                      <div
                        key={doc.key} // Using file name as key
                        className="d-flex align-items-center justify-content-between p-1 border rounded mb-2"
                        style={{
                          backgroundColor: "#f8f9fa",
                          cursor: "pointer",
                        }}
                      >
                        <div
                          className="w-100"
                          onClick={() => {
                            const docUrl = {
                              url: doc?.url,
                            };
                            setSelectedDocument(docUrl);
                            toggleModal();
                          }}
                        >
                          <span className="fs-5">{doc?.name}</span>
                        </div>
                        <button
                          type="button"
                          className="text-danger mx-2 bg-light"
                          onClick={() => handleDeleteDocument(doc.id)}
                        >
                          <DeleteIcon />
                        </button>
                      </div>
                    ))}
                </div>

                {/* <div className="col-12 col-md-6 col-lg-8 w-100">
                  <div className="form-group mb-3">
                    <label htmlFor="desc" className="form-label">
                      Description
                    </label>
                    <textarea
                      className="form-control "
                      id="desc"
                      rows="3"
                      {...register("description")}
                    />
                  </div>
                </div> */}
                <div className="col-12 ">
                  <div className="form-group mb-3">
                    <label htmlFor="totalLeavePerMonth" className="form-label">
                      Description
                      {/* <span className="text-danger">*</span> */}
                    </label>
                    <Controller
                      name="content"
                      control={control}
                      rules={
                        {
                          // required: "Description is required",
                        }
                      }
                      render={({ field }) => (
                        <div>
                          <CKEditor
                            {...field}
                            editor={ClassicEditor}
                            data={field.value || ""}
                            onChange={(event, editor) => {
                              field.onChange(editor.getData());
                            }}
                            config={{
                              toolbar: [
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "underline",
                                "strikethrough",
                                "|",
                                "fontColor",
                                "fontBackgroundColor",
                                "fontFamily",
                                "fontSize",
                                "alignment",
                                "|",
                                "link",
                                "bulletedList",
                                "numberedList",
                                "blockQuote",
                                "undo",
                                "redo",
                              ],
                              image: {
                                toolbar: [
                                  "imageStyle:alignLeft",
                                  "imageStyle:alignCenter",
                                  "imageStyle:alignRight",
                                  "|",
                                  "imageTextAlternative",
                                ],
                              },
                              height: "500px",
                            }}
                          />
                          <ErrorMessage message={errors?.content?.message} />
                        </div>
                      )}
                    />
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center justify-content-end">
                <button
                  disabled={isLoading}
                  type="submit"
                  className="btn btn-primary px-5"
                >
                  {isLoading ? <Spinner /> : EditData ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
      <ViewDocumentModal
        modal={modal}
        toggle={toggleModal}
        selectedDocument={selectedDocument}
      />
    </>
  );
}
